import { BaseComponent } from './../baseComponent';
import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPdfComponent } from './../modal-pdf/modal-pdf.component';
import { BaseService } from './../../../_services/base.service';
import { Adal5Service } from 'adal-angular5';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-map-popover',
  templateUrl: './map-popover.component.html',
  styleUrls: ['./map-popover.component.scss'],
  entryComponents: [ModalPdfComponent]
})
export class MapPopoverComponent extends BaseComponent implements OnInit {
  @Input() data: any;
  @Input() categoryObj: any;
  categoryName: any;
  hasExceed = false;
  hasBoost = false;
  hasImprove = false;
  hasEnhance = false;
  item: any = this.data;
  hasName = false;

  mapID: number;
  sub;
  mapTitle: any;

  constructor(
    private adalService: Adal5Service,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private baseService: BaseService) { super(adalService); }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      this.mapID = +params['id'];
      this.mapTitle = params['title'];
    });

    this.categoryName = this.categoryObj.filter(res => res.categoryId === this.data.categoryId);

    if (this.data.processMapId === 1 || 2) {
      if (this.data.categoryId === 3 || this.data.categoryId === 6) {
        this.hasExceed = true;
      }
      if (this.data.categoryId < 5) {
        this.hasImprove = true;
      }
      if (this.data.categoryId === 1) {
        this.hasEnhance = true;
      }
    }
    if (this.data.processMapId === 2) {
      if (this.data.categoryId === 1 || this.data.categoryId === 2) {
        this.hasExceed = true;
      }
    }
  }
  openModal(content, eventType) {
    this.item = this.data;
    const mapTitle = this.mapTitle;
    const category = this.getCategoryName(content._parentView.context.data.categoryId, content._parentView.context.categoryObj);
    const pointOfInterestNumber = content._parentView.context.data.number;
    const title = content._parentView.context.data.title;

    this.customEvent(eventType, this.mapTitle, category, pointOfInterestNumber, title, this.item.longDescription);

    this.modalService.open(content, { windowClass: 'pdf-modal' });
  }

  public get hasPDF() {
    if (this.data.longDescription !== null || this.data.longDescription !== '') {
      return true;
    }
  }

  customEvent(eventType, mapTitle, category, pointOfInterestNumber, title, documentName) {
    const properties = {
      'accountId': this.adalService.userInfo.username.split('@', 1),
      'authId': this.adalService.userInfo.username,
      'ipaddr': this.adalService.userInfo.profile.ipaddr,
      'mapTitle': this.getMapTitle(),
      'category': category,
      'pointOfInterestNumber': pointOfInterestNumber,
      'title': title,
      'documentName': documentName,
      'URL': window.location.href
    };

    this.logCustomEvent(eventType, properties);
  }

  getMapTitle() {
    this.route.queryParams.subscribe(params => {
      return params.title;
    });
  }

  getCategoryName(categoryId, categories) {
    for (let i = 0; i < categories.length; i++) {
      if (categories[i].categoryId === categoryId) {
        return categories[i].name;
      }
    }
  }

  getPbUrl(baseURL, path) {
    if (baseURL.endsWith('/')) {
      return baseURL + path;
    } else {
      return (baseURL + '/' + path);
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/shared/map-popover/map-popover.component.ts